export enum DATE_FIELD_DATE_VALIDATION {
  ANY = 'any',
  PAST_DATE = 'past_date',
  FUTURE_DATE = 'future_date',
  TODAYS_DATE = 'todays_date',
}
